var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 30,
    viewBox: "0 0 80 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6855 29.3005V0.399414H69.5014C76.0082 0.399414 80 4.47111 80 10.3391C80 16.3269 75.9283 20.2389 69.3019 20.2389H64.4717V29.3005H57.6855ZM64.4717 14.8499H68.0644C71.2579 14.8499 72.9744 13.0536 72.9744 10.3391C72.9744 7.62468 71.2579 5.90818 68.0644 5.90818H64.4717V14.8499Z",
    fill: "#00BD4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0236 9.81997C47.345 7.38494 45.389 5.98779 42.5548 5.98779C38.3234 5.98779 35.6089 9.18127 35.6089 14.8098C35.6089 20.4782 38.1637 23.7116 42.5548 23.7116C46.4069 23.7116 48.5825 21.6957 48.6623 18.5621H42.8342V13.5723H55.2089V17.3646C55.2089 25.0689 49.8998 29.6994 42.5148 29.6994C34.2517 29.6994 28.6631 24.031 28.6631 14.8896C28.6631 5.42893 34.7307 0 42.3951 0C49.0615 0 54.211 4.07169 54.9295 9.81997H48.0236Z",
    fill: "#FEC901"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3605 9.81997C18.6819 7.38494 16.7259 5.98779 13.8917 5.98779C9.66029 5.98779 6.94583 9.18127 6.94583 14.8098C6.94583 20.4782 9.50062 23.7116 13.8917 23.7116C17.7438 23.7116 19.9194 21.6957 19.9992 18.5621H14.1711V13.5723H26.5458V17.3646C26.5458 25.0689 21.2367 29.6994 13.8517 29.6994C5.5886 29.6994 0 24.031 0 14.8896C0 5.42893 6.06762 0 13.732 0C20.3984 0 25.5479 4.07169 26.2664 9.81997H19.3605Z",
    fill: "#FE570B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.12e4346d28c15240f7f01280fba9a3b9.svg";
export { ForwardRef as ReactComponent };